<template>
		<div id="app">
				<router-view />
		</div>
</template>

<script>
		import bus from './bus'
		
		export default {
				name: 'app',
				/*
				mounted() {
						// 友盟访问统计
						const script = document.createElement('script')
						script.src = 'https://s13.cnzz.com/z_stat.php?id=1264345473&web_id=1264345473'
						script.language = 'JavaScript'
						document.body.appendChild(script)
				},
				watch: {
						//       友盟统计
						'$route'() {
								if (window._czc) {
										let location = window.location
										let contentUrl = location.pathname + location.hash
										let refererUrl = '/'
										window._czc.push(['_trackPageview', contentUrl, refererUrl])
								}
						}
				}
				*/
		}
</script>

<style>
		html{
		    width: 100%;
		    min-width: 1210px;
		    height:auto;
		    height: 100%;
		    margin: 0;
		    padding: 0;
		    list-style: none;
		    border: 0;
		    /* font-family:"Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif; */
		    /* //font-family: Helvetica; */
		    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		    background: #f3f3f3;
		    overflow-x:auto;
		    overflow-y: hidden;
		}
		body{
		    width:1210px;
		    min-height: 100%;
		    margin: 0 auto;
		    padding: 0;
		    list-style: none;
		    border: 0;
		    /* font-family: Helvetica;
		    font-family:"Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif; */
		    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		    background: #f3f3f3;
		    height: 100%;
		    overflow-x: scroll;
		    position: relative;
		}
		h1, h2, h3, h4, h5, h6, input, button, ul, li, a, p, textarea {
		    margin: 0;
		    padding: 0;
		    list-style: none;
		    border: 0;
		}

		img {
		    display: inline-block;
		}

		a:link {
		    text-decoration: none;
		}

		a:visited {
		    text-decoration: none;
		}

		a:hover {
		    text-decoration: none;
		}

		a:active {
		    text-decoration: none;
		}
		input,textarea{
		    border: 0;
		    -webkit-appearance: none;
		}
		button, input, a ,textarea{
		    outline: none;
		}

		button {
		    cursor: pointer;
		}
		::-ms-clear,
		::-ms-reveal
		{
		display:none;
		}
		::-webkit-input-placeholder { /* WebKit browsers */
		    color:    #B2BCC9;
		}
		:-moz-placeholder {/*  Mozilla Firefox 4 to 18 */
		    color:   #B2BCC9;
		}
		::-moz-placeholder { /* Mozilla Firefox 19+ */
		    color:   #B2BCC9;
		}
		:-ms-input-placeholder { /* Internet Explorer 10+ */
		    color:   #B2BCC9 ! important ;
		}

		/*color*/
		.gray6 {
		    color: #999999;
		}

		.gray6 {
		    color: #666666;
		}

		.gray3 {
		    color: #333333;
		}
		.gray2 {
		    color: #222;
		}


		.gray94 {
		    color: #949494;
		}

		.gray5 {
		    color: #555555;
		}

		.gray9 {
		    color: #999999;
		}

		.gray3f {
		    color: #3f3f3f;
		}
		.grayb5{
		    color: #b5b5b5;
		}

		.black {
		    color: #000;
		}

		.white {
		    color: #fff;
		}

		.border {
		    border: 1px solid rgba(203, 203, 203, .5);
		    border-radius: 2px;
		}



		/*省略号*/
		.hidden {
		    overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
		    -o-text-overflow: ellipsis;
		}

		/*居中*/
		.middle {
		    /*firefox*/
		    display: -moz-box;
		    -moz-box-pack: center;
		    -moz-box-align: center;
		    /*safari.opera以及chrome*/
		    display: -webkit-box;
		    -webkit-box-pack: center;
		    -webkit-box-align: center;

		    /*w3c*/
		    display: box;
		    box-pack: center;
		    box-align: center;
		}

		#app {
				width: 100%;
				height: 100%;
				/* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
				/* font-family:"Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif; */
				font-family: Helvetica, Arial, "Microsoft Yahei", "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
		}
</style>



// WEBPACK FOOTER //
// src/App.vue